__turbopack_context__.v({
  "buttonsWrapper": "VkteVq_buttonsWrapper",
  "collapse": "VkteVq_collapse",
  "pricingDetails": "VkteVq_pricingDetails",
  "row": "VkteVq_row",
  "sectionTitle": "VkteVq_sectionTitle",
  "tabletContent": "VkteVq_tabletContent",
  "wrapper": "VkteVq_wrapper",
});
